import React from "react";
import { Route, Routes } from "react-router-dom";
import { ROUTES } from "./modules/core/models/enums/routes";
import ProtectedRoutes from "./modules/core/protectedRoutes";
import PublicRoutes from "./modules/core/publicRoutes";
import ResetPasswordContainer from "./modules/auth/container/resetPasswordContainer";
const Auth = React.lazy(() => import("./modules/auth"));
const Feature = React.lazy(() => import("./modules/feature/Feature"));

function AppRoutes() {
  return (
    <Routes>
      {/* completely public, no guards */}
      <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordContainer />} />
      
      <Route path="*" element={<PublicRoutes isRestricted={true} />}>
        <Route path="*" element={<Auth />} />
      </Route>

      <Route
        path={ROUTES.ADMIN}
        element={<ProtectedRoutes isRestricted={false} />}
      >
        <Route path="*" element={<Feature />} />
      </Route>

    </Routes>
  );
}

export default AppRoutes;
